export const BACKEND_API = process.env.REACT_APP_BACKEND_API;
export const VERIFY_AUTHENTICATION_STATUS =
  localStorage.getItem("isAuthenticated") || false;
export const PROFILE_PICTURE = localStorage.getItem("photoURL");
export const GUEST_USER_ACCESS = localStorage.getItem(
  "GUEST_USER_ACCESS"
) as any;

export const FUNDING_GUEST_USER_ACCESS_TIMES = 2;

//remove this header
export const API_HEADERS = {
  "Content-Type": "application/json",
};

export const ICONS = {
  PERSON: "person",
  REAL_ESTATE_AGENT: " real_estate_agent",
  CACHED: "cached",
};

export const PREVIEW_CATEGORIES = {
  APARTMENT: "Want to search apartment",
  HOME: "Want to search home",
  VILLA: "Want to search villa",
  FARM_HOUSE: "Want to search farm house",
  PENT_HOUSE: "Want to search pent house",
};

export const HOMEPAGE_VIDEO =
  "https://firebasestorage.googleapis.com/v0/b/alarm-a709f.appspot.com/o/property%2FBB_379d6b89-b69e-4f43-adc9-b1b45aa7d345_FPpreview%20(online-video-cutter.com).mp4?alt=media&token=17f427da-d785-4c09-9cd3-e836369ef575";

export const PROPERTY_VIDEO =
  "https://s7d9.scene7.com/is/content/aimcoprod/Southgate_BrandVideo_112022-hd";

export const LOGO =
  "https://firebasestorage.googleapis.com/v0/b/houzzbot.appspot.com/o/main-Houzzbott-logo.png?alt=media&token=3ab65130-c2d2-4cf4-9048-bb667dc35fc4";

export const HOMEPAGE_IMAGE =
  "https://firebasestorage.googleapis.com/v0/b/houzzbot.appspot.com/o/homapage.webp?alt=media&token=dd5a05aa-731a-4291-858d-70d826db70c1";

export const PROPERTY_LOADER =
  "https://firebasestorage.googleapis.com/v0/b/houzzbot.appspot.com/o/property.gif?alt=media&token=5ea2d058-b3aa-4dec-ab21-38d66755cfec";

const center = { lat: 50.064192, lng: -130.605469 };
export const defaultBounds = {
  north: center.lat + 0.1,
  south: center.lat - 0.1,
  east: center.lng + 0.1,
  west: center.lng - 0.1,
};

export const INTIAL_MESSAGES = [
  {
    id: 1,
    user: "what is stack",
    chatgpt:
      "In computer science, a stack is a linear data structure that follows the Last-In-First-Out (LIFO) principle. It is an abstract data type that represents a collection of elements, where elements can be added or removed only from one end, called the top of the stack.",
  },
];

export const MOCK_MESSAGES = [
  {
    builder_name: "Akshaya Developers",
    ongoing_projects: [
      {
        city: "Hyderabad",
        latitude: 17.3852,
        longitude: 78.4866,
        project_name: "Akshaya Greens",
        units_available: 100,
      },
      {
        city: "Hyderabad",
        latitude: 17.3852,
        longitude: 78.4866,
        project_name: "Akshaya Towers",
        units_available: [50, 30],
      },
    ],
  },
  {
    builder_name: "Hyderabad Builders",
    ongoing_projects: [
      {
        city: "Hyderabad",
        latitude: 17.3852,
        longitude: 78.4866,
        project_name: "Hyderabad Towers",
        units_available: 100,
      },
      {
        city: "Hyderabad",
        latitude: 17.3852,
        longitude: 78.4866,
        project_name: "Hyderabad Greens",
        units_available: 50,
      },
    ],
  },
  {
    builder_name: "Hyderabad Builders",
    ongoing_projects: [
      {
        city: "Hyderabad",
        latitude: 17.3852,
        longitude: 78.4866,
        project_name: "Hyderabad Towers",
        units_available: 100,
      },
      {
        city: "Hyderabad",
        latitude: 17.3852,
        longitude: 78.4866,
        project_name: "Hyderabad Greens",
        units_available: 50,
      },
    ],
  },
];

export const ANOTHER_MOCK_MESSAGES = [
  {
    builder: {
      email: "info@adanirealty.com",
      name: "Adani Realty",
      phone: "0124-4000000",
      website: "https://www.adanirealty.com/",
    },
    project: {
      latitude: 28.6541,
      location: "Delhi",
      longitude: 77.2323,
      name: "Adani Shantigram",
      ongoing: true,
      unitsAvailable: 100,
    },
  },
  {
    builder: {
      email: "info@dlf.com",
      name: "DLF",
      phone: "011-23456789",
      website: "https://www.dlf.com/",
    },
    project: {
      latitude: 28.6542,
      location: "Delhi",
      longitude: 77.2324,
      name: "DLF Galleria",
      ongoing: true,
      unitsAvailable: 50,
    },
  },
  {
    builder: {
      email: "info@emaarmgf.com",
      name: "Emaar MGF",
      phone: "011-45678901",
      website: "https://www.emaarmgf.com/",
    },
    project: {
      latitude: 28.6543,
      location: "Delhi",
      longitude: 77.2325,
      name: "Emaar Golf City",
      ongoing: true,
      unitsAvailable: 25,
    },
  },
];

export const INITIAL_CHAT_DATAS = [
  {
    id: 1,
    user: "",
    response: "",
  },
];

export const INITIAL_COMPARISION_DATAS = [
  {
    id: 1,
    user: "",
    response: "",
  },
];

export const INITAL_TRAIN_DATAS = [
  {
    id: 1,
    user: "",
    response: "",
  },
];

export enum API_ROUTES {
  ASK_HOUZZ = "askHouzz",
  TRAIN = "train",
}